export default "__VITE_ASSET__R_oH0IKW__"